import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Emitter } from 'vscode/vscode/vs/base/common/event';
import { Disposable, toDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IExtensionService } from 'vscode/vscode/vs/workbench/services/extensions/common/extensions.service';

let ChatSlashCommandService = class ChatSlashCommandService extends Disposable {
    constructor(_extensionService) {
        super();
        this._extensionService = _extensionService;
        this._commands = ( new Map());
        this._onDidChangeCommands = this._register(( new Emitter()));
        this.onDidChangeCommands = this._onDidChangeCommands.event;
    }
    dispose() {
        super.dispose();
        this._commands.clear();
    }
    registerSlashCommand(data, command) {
        if (( this._commands.has(data.command))) {
            throw ( new Error(`Already registered a command with id ${data.command}}`));
        }
        this._commands.set(data.command, { data, command });
        this._onDidChangeCommands.fire();
        return toDisposable(() => {
            if (this._commands.delete(data.command)) {
                this._onDidChangeCommands.fire();
            }
        });
    }
    getCommands() {
        return Array.from(( this._commands.values()), v => v.data);
    }
    hasCommand(id) {
        return ( this._commands.has(id));
    }
    async executeCommand(id, prompt, progress, history, token) {
        const data = this._commands.get(id);
        if (!data) {
            throw ( new Error('No command with id ${id} NOT registered'));
        }
        if (!data.command) {
            await this._extensionService.activateByEvent(`onSlash:${id}`);
        }
        if (!data.command) {
            throw ( new Error(`No command with id ${id} NOT resolved`));
        }
        return await data.command(prompt, progress, history, token);
    }
};
ChatSlashCommandService = ( __decorate([
    ( __param(0, IExtensionService))
], ChatSlashCommandService));

export { ChatSlashCommandService };
